import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { CheckCircleOutline as CheckCircleIcon } from '@mui/icons-material';

const Message = () => {
  return (
    <section className="auth-section" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Card sx={{ width: '100%', maxWidth: 400, padding: 2 }} elevation={3}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
            <CheckCircleIcon sx={{ fontSize: 54, color: '#4caf50' }} />
          </Box>
          <Typography variant="h5" component="h3" align="center" gutterBottom sx={{ fontWeight: 'bold', color: '#3F51B5', marginBottom: 2 }}>
            Password Changed!
          </Typography>
          <Typography variant="body1" align="center" sx={{ marginBottom: 2 }}>
            Your password has been changed successfully.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: '#3F51B5', color: 'white', '&:hover': { backgroundColor: '#3F51B5d4' } }}
              component={Link}
              to="/"
            >
              Click to Login
            </Button>
          </Box>
        </CardContent>
      </Card>
    </section>
  );
};

export default Message;
